var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#1C6A69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3851 23.4456C19.7349 25.5682 15.8554 25.4011 13.3987 22.9444C10.7626 20.3083 10.7626 16.0345 13.3987 13.3984C16.0347 10.7624 20.3086 10.7624 22.9446 13.3984C25.4014 15.8552 25.5685 19.7346 23.4458 22.3849L28.6014 27.5405C28.8943 27.8334 28.8943 28.3083 28.6014 28.6012C28.3085 28.8941 27.8337 28.8941 27.5408 28.6012L22.3851 23.4456ZM14.4593 21.8837C12.4091 19.8334 12.4091 16.5093 14.4593 14.4591C16.5096 12.4088 19.8337 12.4088 21.8839 14.4591C23.9327 16.5078 23.9342 19.8286 21.8885 21.8792C21.8869 21.8807 21.8854 21.8822 21.8839 21.8837C21.8824 21.8852 21.8809 21.8867 21.8794 21.8882C19.8288 23.9339 16.5081 23.9324 14.4593 21.8837Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1c0e5b4930f961794464e9fa20633a30.svg";
export { ForwardRef as ReactComponent };